export const obavijest_sudu_o_prestanku_radnog_odnosa= {
    templateId: 72,
    category: 7,
    templateTitle: 'Ovrha - obavijest sudu o prestanku radnog odnosa s radnikom (kad poslodavcu nije poznat novi poslodavac)',
    templateDescription: `<p>Kod prestanka radnog odnosa radnika protiv kojega je Poslodavac zaprimio rješenje o ovrsi, Poslodavac je dužan o prestanku radnog odnosa sud (u slučaju da mu nije poznat eventualni novi poslodavac radnika).</p>`,

    description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Kod prestanka radnog odnosa radnika za kojega je zaprimio rješenja o ovrsi, poslodavac ima sljedeće obveze:</p>
    <li> ukoliko mu je poznat novi poslodavac - bez odgode preporučenom pošiljkom s povratnicom dostaviti rješenje o ovrsi novom poslodavcu prema primjeru <a class="local-link" href="/contract?template=71">ovdje</a> i o tome obavijestiti sud prema primjeru <a class="local-link" href="/contract?template=72.1">ovdje</a>, </li>
    <li> ukoliko mu nije poznat novi poslodavac - bez odgode obavijestiti sud o prestanku ugovora o radu prema dolje navedenom primjeru, o čemu će sud obavijestiti ovrhovoditelja, određujući mu rok radi pribave podataka o novom poslodavcu.</li>
    <br>
    <p>Poslodavac koji je propustio postupiti prema navedenim obvezama,  odgovara za štetu koju je ovrhovoditelj zbog toga pretrpio.</p>
    <p>Primjerak dolje navedene obavijesti odnosi se na situaciju u kojoj se o prestanku radnog odnosa obavještava sud.</p>
    <p>Sličan je postupak kod postupanja s osnovama za plaćanje (privatne isprave s učinkom o rješenju o ovrsi) te je poslodavac dužan predati navedenu ispravu novom poslodavcu, ukoliko mu je poznat te o tome obavijestiti vjerovnika ili je dužan ispravu vratiti vjerovniku preporučenom pošiljkom uz povratnicu.</p>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Povrat osnove za plaćanje radniku (dužniku), slanje osnove za plaćanje krivom adresatu/primatelju ili nepostupanje prema obvezama iz Ovršnog zakona</strong></p>
    <p>Pojašnjenje:  postoji opasnost za poslodavca da će odgovarati za štetu vjerovniku ukoliko ispravu preda trećemu (radniku ili bilo kojoj drugoj osobi) ili ne postupi kako je zakonom određeno. Iz navedenih razloga, uvijek je potrebno postupiti kako je gore navedeno.</p>

    <h5>PRAVNA OSNOVA</h5> 

    <p>Ovršni zakon.</p>
  `,

  sides: [
    {
      prefix: "",
      signature: "",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Naziv suda",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto i poštanski broj",
      },
    ],
      suffix: "",
    }
  ],

  headline: "",

    title: '\r\n\r\nPREDMET: Obavijest sudu o prestanku radnog odnosa',
    noArticleNumbers: true,
    noArticleTitle: true,

    articles: [

        {
            title: "",
            mandatory: true,
            dummy: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  { type: "text", content: "Na poslovni broj:OVR-" },
                  { type: "input", value: "", required: true, help: "Potrebno je upisati broj predmeta u kojemu je doneseno rješenje o ovrsi - broj predmeta ima naznaku OVR."},
                ],
              }
            ]
          },
                {
                    title: '',
                    mandatory: true,
                    dummy: true,
                    exampleContent: true,
                    statements: [
                        {
                            type: 'text',
                            mandatory: true,
                            editable: true,
                            content: 'Poštovani,\r\n\r\nsukladno čl. 200. Ovršnog zakona, a budući da nam nije poznat novi poslodavac radnika protiv kojega je izdano rješenje o ovrsi u ovom predmetu, obavještavamo sud da je radniku  ______________, iz _________________, prestao radni odnos dana __.___.______. godine. \r\n \r\n\r\nS poštovanjem.',
                            value: '',
                        }],
                },
                {
                    mandatory: true,
                    static: true,
                    type: 2, // date and place
                    statements: [
                      {
                        type: "input",
                        mandatory: true,
                        parts: [
                          {
                            type: "text",
                            content: "U"
                          },
                          {
                            type: "input",
                            value: "",
                            placeholder: "Upišite mjesto.",
                            required: true,
                          },
                          {
                            type: "text",
                            content: ", dana"
                          },
                          {
                            type: "date",
                            value: new Date(),
                            required: true
                          },
                          {
                            type: "text",
                            content: "godine."
                          }
                        ]
                      },
                    ]
                  },
                {
                    mandatory: true,
                    static: true,
                    type: 3,  // signatures
                    statements: [],
                },
                {
                    static: true,
                    mandatory: false,
                    type: 4, 
                    statements: [
                      {
                        type: 'text',
                        mandatory: true,
                        editable: true,
                        content: 'Dostaviti:\r\n1) Sudu \r\n2) Kadrovska služba \r\n',
                        help: 'Po želji, slobodno dopišite kome želite dostaviti dopis odnosno izmijenite/obrišite predložene unose.'
                      }
                    ]
                  },
            ],
};












// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/72_obavijest_sudu_o prestanku_radnog_odnosa.ts